import React, {PureComponent} from 'react';
import {Classes, Overlay} from '@blueprintjs/core';
import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import toastr from 'toastr';

export default class DeleteRssModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                team_name: props.team_name || "",
                team_id: props.team_id || "",
                admin_id: props.admin_id || ""
            },
            errors: {},
            spinnerActive: false
        };
    }

    doSubmit = async (e) => {
        try {
            this.setState({spinnerActive: true})
            const result = await http.patch('api/feed/' + this.props.thisSource.id, {rss: ''}, {headers: {authorization: getJwt()}});
            this.props.updateUserFromServer()
            this.setState({spinnerActive: false})
            this.props.handleClose();
        } catch {
            toastr.error("Deleting RSS data wasn't successful")
            this.setState({spinnerActive: false})
        }
    };


    render() {
        let {thisSource} = this.props;

        return (
            <Overlay
                // onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER}
                // isOpen={this.state.overlayIsOpen}
                isOpen={this.props.showModal}
            >
                <div className="modal-field-payment"
                     style={{width: 500}}>
                    <div className="add-payment-method-modal-container">

                        <div className='modal-title'>
                            <p className="modal-close-button" onClick={this.props.handleClose}><i
                                className="fas fa-times"></i></p>
                            <h2 className=''>Delete RSS data</h2>
                        </div>
                        <div className="modal-main">
                            <div className='margin-top-20 margin-bottom-20'>

                                <span
                                    className="">Are you certain that you want to delete: <strong>{thisSource ? thisSource.rss : ''}</strong> ?</span>
                            </div>
                            <div className='justify-content-end flex-direction-row margin-bottom-20'>
                                <button disabled={false}
                                        onClick={this.props.handleClose}
                                        name="cancel_delete_tag"
                                        id="cancel_delete_tag"
                                        type="button"
                                        className="btn-white-border margin-right-10"
                                >
                                    Cancel
                                </button>


                                {!this.state.spinnerActive ?
                                    <button disabled={false}
                                            name="delete_tag"
                                            id="delete_tag"
                                            type="button"
                                            onClick={this.doSubmit}
                                            className="btn-danger">Delete</button>
                                    :
                                    <button disabled={false}
                                            name="delete_tag"
                                            id="delete_tag"
                                            type="button"
                                            onClick={this.doSubmit}
                                            className="btn-danger btn-spinner">Delete <i
                                        className='fa fa-spin fa-spinner'></i></button>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </Overlay>
        )
    }
}

